import { React, useState, useRef, useEffect } from "react";
const BetfairFancy = ({
  eventDetails,
  betfairFancyData,
  setBetSlipDetails,
  getBetPlaceSessionList,
  userInfo,
  onChildRuleShow
}) => {
  const [showSessionPlPopup, setShowSessionPlPopup] = useState(false);

  const [sessionPLList, setSessionPLList] = useState({});
  const [sessionName, setSessionName] = useState("");

  const showBetSlip = (betType, teamName, sid, rate, price, sectionId) => {
    setBetSlipDetails({
      bet_type: betType,
      runnername: teamName,
      sid: sid,
      odds: rate,
      amount: 0,
      price: price,
      market_type: "betfairfancy",
      sectionId: sectionId
    });
  };

  const showRules = () => {
    onChildRuleShow();
  };
  const getColor = (amount) => {
    if (amount < 0) {
      return "position-minus";
    } else {
      return "position-plus";
    }
  };
  const getSessionBook = (marketid) => {
    let returnArr = "";
    const savedData = getBetPlaceSessionList;

    if (savedData !== null && savedData.length > 0) {
      let bookAmt = [];
      for (let i = 0; i < savedData.length; i++) {
        let obj = savedData[i];
        let key = obj.key;

        if (
          key !== undefined &&
          key !== null &&
          key === marketid + "_" + userInfo?._id
        ) {
          let values = obj.value;
          Object.values(values).map((value) => bookAmt.push(value));
          const min = Math.min(...bookAmt);
          const max = Math.max(...bookAmt);
          returnArr = (
            <span>
              <span
                style={{
                  color: "#f00",
                  fontWeight: "bold",
                  paddingLeft: "0px",
                  fontSize: "15px"
                }}
              >
                {min}
              </span>
              <span
                style={{
                  color: "#00b181",
                  fontWeight: "bold",
                  paddingLeft: "8px",
                  fontSize: "15px"
                }}
              >
                {max}
              </span>
            </span>
          );
        }
      }
    }
    return returnArr;
  };

  const ShowBook = async (teamName, sid, evt_id) => {
    let betObj = {};
    betObj.eid = evt_id;
    betObj.mid = sid;
    betObj.rname = teamName;
    setSessionName(teamName);

    const savedData = getBetPlaceSessionList;

    if (savedData !== null && savedData.length > 0) {
      for (let i = 0; i < savedData.length; i++) {
        let obj = savedData[i];
        let key = obj.key;

        if (
          key !== undefined &&
          key !== null &&
          key === sid + "_" + userInfo?._id
        ) {
          let values = obj.value;

          setSessionPLList(values);
          setShowSessionPlPopup(true);
        }
      }
    }
  };

  const closeSessionPlSlip = () => {
    setShowSessionPlPopup(false);
  };

  return (
    <div style={{ display: "block" }}>
      <div className="table-box-body">
        <div className="tb-content">
          <div className="market-titlebar">
            <p className="market-name">
              <span className="market-name-badge">
                <i className="market-name-icon">
                  <img
                    src="/assets/images/time-img.png"
                    style={{
                      filter: "invert(100%)",
                      marginTop: "-8px",
                      marginLeft: "-1px"
                    }}
                  />
                </i>
                <span>
                  Betfair Fancy Bet{" "}
                  <span style={{ textTransform: "initial" }}>
                    (MaxBet: 200K)
                  </span>
                </span>{" "}
                <span style={{ textTransform: "initial" }}></span>
              </span>
              <span className="rules-badge" onClick={() => showRules()}>
                <i className="fa fa-info-circle"></i>
              </span>
            </p>
            <div className="market-overarround">
              <span></span>
              <strong>BACK</strong>
            </div>
            <div className="market-overarround market-overarround-lay">
              <strong>LAY</strong>
            </div>
          </div>
          <div className="market-runners">
            {betfairFancyData !== null &&
              betfairFancyData !== undefined &&
              betfairFancyData !== "" &&
              betfairFancyData.map((fancy) => (
                <div className="runner-runner">
                  <h3 className="runner-name">
                    <table>
                      <tr>
                        <td>
                          <div className="runner-info">
                            <span className="clippable runner-display-name">
                              <h4
                                className="clippable-spacer"
                                style={{
                                  fontWeight: "normal",
                                  textTransform: "capitalize",
                                  wordWrap: "break-word",
                                  whiteSpace: "break-spaces",
                                  lineHeight: "21px",
                                  fontSize: "15px",
                                  fontWeight: "600"
                                }}
                              >
                                {fancy.market}
                              </h4>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div>
                            {getSessionBook(fancy.marketid)}
                            <a
                              className="pldetails"
                              onClick={() =>
                                ShowBook(
                                  fancy.market,
                                  fancy.marketid,
                                  fancy.evt_id
                                )
                              }
                              style={{
                                color: "#00b181",
                                fontWeight: "bold",
                                paddingLeft: "0px",
                                fontSize: "15px"
                              }}
                            >
                              Book
                            </a>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </h3>

                  <div className="price-row-box-new">
                    <a
                      className="price-price price-lay"
                      style={{ background: "#e8f6fc" }}
                    >
                      &nbsp;
                    </a>
                    <a
                      className="price-price price-lay mr-4"
                      style={{ background: "#e8f6fc" }}
                    >
                      &nbsp;
                    </a>

                    <a
                      onClick={() =>
                        showBetSlip(
                          "B",
                          fancy.market,
                          fancy.marketid,
                          fancy.bak,
                          fancy.bakrate,
                          fancy.sectionId
                        )
                      }
                      className="price-price price-back mb-show"
                      style={{
                        backgroundColor: "rgb(141, 210, 240)",
                        textDecoration: "none",
                        color: "black"
                      }}
                    >
                      <div>
                        <span className="price-odd">{fancy.bak}</span>
                        <span className="price-amount">{fancy.bakrate}</span>
                      </div>
                    </a>
                    <a
                      className="price-price price-lay mb-show ml-4"
                      style={{
                        backgroundColor: "rgb(254, 175, 178)",
                        textDecoration: "none",
                        color: "black"
                      }}
                      onClick={() =>
                        showBetSlip(
                          "L",
                          fancy.market,
                          fancy.marketid,
                          fancy.lay,
                          fancy.layrate,
                          fancy.sectionId
                        )
                      }
                    >
                      <div>
                        <span className="price-odd">{fancy.lay}</span>
                        <span className="price-amount">{fancy.layrate}</span>
                      </div>
                    </a>
                    <a
                      className="price-price price-back"
                      style={{ background: "#fce3e4" }}
                    >
                      &nbsp;
                    </a>
                    <a
                      className="price-price price-back"
                      style={{ background: "#fce3e4" }}
                    >
                      &nbsp;
                    </a>

                    <div
                      className="suspended-overlap"
                      style={{
                        display: fancy.status === "OPEN" ? "" : "none"
                      }}
                    >
                      Suspended
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      {showSessionPlPopup && (
        <div>
          <div className="modal d-block">
            <div className="modal-dialog">
              <div className="modal-content" style={{ width: "99%" }}>
                <div style={{ borderRadius: "6px", background: "white" }}>
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td>
                        <span
                          style={{
                            paddingTop: "13px",
                            paddingLeft: "13px",
                            paddingBottom: "0px",
                            fontSize: "18px",
                            fontWeight: "bold",
                            color: "black"
                          }}
                        >
                          {sessionName}
                        </span>
                      </td>
                      <td style={{ textAlign: "right", paddingRight: "13px" }}>
                        {" "}
                        <button
                          type="button"
                          data-dismiss="modal"
                          aria-label="Close"
                          class="close"
                          onClick={() => closeSessionPlSlip()}
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </td>
                    </tr>
                  </table>

                  <div
                    className="modal-body"
                    style={{ height: "500px", overflowX: "auto" }}
                  >
                    <table className="table">
                      <tbody>
                        <tr>
                          <th style={{ color: "black" }}>Score</th>
                          <th style={{ color: "black" }}>Position</th>
                        </tr>
                        {Object.keys(sessionPLList).map((key) => (
                          <tr>
                            <td style={{ color: "black" }}>{key}</td>
                            <td className={getColor(sessionPLList[key])}>
                              {sessionPLList[key]}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default BetfairFancy;
